import { useState } from 'react';
import ExportsTable from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryExportsTable/ExportsTable/ExportsTable';
import PortfolioHistoryExportsTableControls from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryExportsTable/PortfolioHistoryExportsTableControls';
import { PortfolioHistoryExportTypeFilter } from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryExportsTable/types';

export default function PortfolioHistoryExportsTable() {
	const [exportTypeFilter, setExportTypeFilter] =
		useState<PortfolioHistoryExportTypeFilter>('all');

	return (
		<div>
			<PortfolioHistoryExportsTableControls
				exportTypeFilter={exportTypeFilter}
				setExportTypeFilter={setExportTypeFilter}
			/>
			<ExportsTable exportTypeFilter={exportTypeFilter} />
		</div>
	);
}
